export const PRIMARY_COLOR = '#000a2e';
export const SECONDARY_COLOR = '#dedc00';
export const TERTIARY_COLOR = '#0561fc';
export const FOURTH_COLOR = '#9d9d9c';
export const TEAL_COLOR = '#236583';
export const DARK_GREY_BLUE = '#435573';
export const DARKER_GREY_BLUE = '#1D2647';
export const ROYAL_BLUE = '#0070ce';
export const DARK_MODERATE_BLUE = '#4169A4';
export const PALE_BLUE = '#d9e9f4';
export const PALE_GREY_BLUE = '#F2F7F8';
export const BLACK = '#000';
export const MATE_BLACK = '#1b1818';
export const BLACK_ALPHA = '#0005';
export const WHITE = '#fff';
export const WHITE_GREY = '#acb1c0';
export const PALE_WHITE = '#eee9';
export const BORDER_GREY = '#ddd';
export const LIGHT_GREY = '#ebeaea';
export const FORM_SEPARATOR = '#f6f6f6';
export const EXTENDED_INFO = '#94A3B8';
export const DEPOSITS_GREY = '#98A6BA';
export const cool_blue = '#0561fc';
export const cool_blue_2 = '#0053cc';
export const highlight_magenta = '#A6258F';
export const highlight_red = '#FE5229';
export const neutral_grey = '#9d9d9c';
export const light_blue = '#71b2ff';
export const light_blue_2 = '#cbd3e3';


export const STATUS_COLOR = {
  PENDING: '#B7B7B7',
  CANCEL: '#F44236',
};
/** @type {{
  LEVEL_1: '#F6F9FA',
  LEVEL_2: '#F7F5F5',
  LEVEL_3: '#EBEAEA',
  LEVEL_4: '#E5E7EB',
  LEVEL_5: '#DFDEDE',
  LEVEL_6: '#ABABAB',
  LEVEL_7: '#636363',
}}*/
export const GRAY_SCALE = {
  LEVEL_1: '#F6F9FA',
  LEVEL_2: '#F7F5F5',
  LEVEL_3: '#EBEAEA',
  LEVEL_4: '#E5E7EB',
  LEVEL_5: '#DFDEDE',
  LEVEL_6: '#ABABAB',
  LEVEL_7: '#636363',
};

export const INACTIVE = GRAY_SCALE.LEVEL_5;
export const BORDER_INACTIVE = INACTIVE;

export const BORDER_ACTIVE = INACTIVE;
export const MODAL_TEXT = '#000';
export const BORDER = GRAY_SCALE.LEVEL_5;
export const INACTIVE_TEXT = GRAY_SCALE.LEVEL_6;
export const ACTIVE_FOREGROUND = '#283460';

export const ALERT = '#FF2D27';
export const FLAT_ALERT = '#FB6363';
export const FLAT_WARNING = '#FFA34A';

export const MAGIC_GRAPH_COLORS = [
  '#283460',
  '#0095CE',
  '#00818A',
  '#62BBAA',
  '#999999',
  '#669999',
  '#99CCCC',
  '#6699FF',
  '#206583',
  '#990099',
  '#336666',
  '#15483A',
  '#009933',
  '#33CC99',
  '#99CC66',
];

export const TRANSPARENT = 'transparent';

export const randomHexColor = () => {
  return ('#' + ((Math.random() * 0xffffff) << 0).toString(16) + '000000').slice(0, 7);
};
